
import React from "react";
import { motion } from "framer-motion";
import "./AboutHero.css";
import logo from '../../assets/images/logo.png';
const AboutHero = () => {
    return (
        <section className="about-hero">
            <div className="about-hero-inner">

                {/* LEFT IMAGE */}
                <motion.div
                    className="about-hero-left"
                    initial={{ opacity: 0, y: 30 }}   // ✅ vertical animation only
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <div className="about-hero-image-wrapper">
                        <img
                            src={logo}
                            alt="Swarna Prakash Jewellers store"
                            className="about-hero-image"
                        />
                    </div>
                </motion.div>

                {/* RIGHT CONTENT */}
                <motion.div
                    className="about-hero-right"
                    initial={{ opacity: 0, y: 30 }}   // ✅ vertical animation only
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >

                    {/* BADGE */}
                    {/* <motion.div
                        className="about-hero-badge"
                        initial={{ rotate: -20, opacity: 0 }}
                        whileInView={{ rotate: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: true }}
                    >
                        <div className="about-hero-badge-inner">
                            <span>Swarna • Since 2024 •</span>
                        </div>
                    </motion.div> */}

                    <p className="about-hero-label">AVNII.IN</p>

                    <h1 className="about-hero-title">
                        AVNII,
                    
                        <br /> a new
                        
                        chapter in a legacy of
                       
                        fine jewellery.
                    </h1>

                    <p className="about-hero-text">
                        Complete Silver Jewelry Collection - Earrings, necklaces, rings, anklets & more—all under one roof
                        Handcrafted & Customizable - Unique oxidized designs and personalized silver pieces made just for you
                        Quality Meets Affordability - Authentic silver at prices that won't break the bank.
 </p>

                    {/* POINTS */}
                    <motion.div
                        className="about-hero-points"
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true }}
                        variants={{
                            hidden: {},
                            show: {
                                transition: { staggerChildren: 0.18 },
                            },
                        }}
                    >
                        {[
                            "Product locally in karnataka, India",
                            "4.8+ rating across the products",
                            "Over 100+ designs",
                        ].map((text, i) => (
                            <motion.div
                                key={i}
                                className="about-hero-point"
                                variants={{
                                    hidden: { opacity: 0, y: 16 },
                                    show: { opacity: 1, y: 0 },
                                }}
                                transition={{ duration: 0.45 }}
                            >
                                <span className="about-hero-point-icon">
                                    {i === 0 ? "📍" : i === 1 ? "⭐" : "🛍️"}
                                </span>
                                <span>{text}</span>
                            </motion.div>
                        ))}
                    </motion.div>

                    <motion.button
                        className="about-hero-button"
                        whileHover={{
                            scale: 1.05,
                            boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                        }}
                        whileTap={{ scale: 0.98 }}
                    >
                        Contact Us
                    </motion.button>
                </motion.div>

            </div>
        </section>
    );
};

export default AboutHero;
